import {Box} from 'src/design/atoms/Box';
import {Title} from 'src/design/atoms/Title';
import React from 'react';
import type {IFormDataV2, IFormFieldV2} from 'src/types/FormV2';
import {FormViewComponentV2} from './FormViewComponentV2';

const exampleFormMeta: IFormFieldV2[] = [
  {
    name: 'heading',
    label: 'Personal Information',
    type: 'heading',
  },
  {
    name: 'firstName',
    label: 'First Name',
    type: 'text',
    size: 'sm',
    required: true,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
    size: 'sm',
    required: true,
  },
  {
    name: 'email',
    label: 'Email',
    type: 'text',
    size: 'sm',
    required: true,
    validation: {
      pattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
      patternError: 'Please enter a valid email address',
    },
  },
  {
    name: 'birthDate',
    label: 'Birth Date',
    type: 'date',
    description: 'Must be at least 18 years old',
  },
  {
    name: 'divider1',
    label: '',
    type: 'divider',
  },
  {
    name: 'heading2',
    label: 'Additional Information',
    type: 'heading',
  },
  {
    name: 'bio',
    label: 'Biography',
    type: 'richtext',
    description: 'This is a description',
  },
  {
    name: 'skills',
    label: 'Skills',
    type: 'select-multiple',
    options: [
      {id: '1', label: 'JavaScript'},
      {id: '2', label: 'TypeScript'},
      {id: '3', label: 'React'},
      {id: '4', label: 'Node.js'},
    ],
  },
  {
    name: 'profilePicture',
    label: 'Profile Picture',
    type: 'file',
    fileUploadOptions: {
      allowedFileTypes: ['image/*'],
      maxFileSize: 5000000,
    },
  },
  {
    name: 'termsAccepted',
    label: 'Terms and Conditions',
    type: 'switch',
    switchOptions: {
      positiveText: 'Accepted',
      negativeText: 'Not Accepted',
    },
    required: true,
  },
  {
    name: 'signature',
    label: 'Signature',
    type: 'signature',
    required: true,
  },
];

const exampleFormData: IFormDataV2 = {
  firstName: 'John',
  lastName: 'Doe',
  email: 'john.doe@example.com',
  birthDate: '1990-01-01',
  bio: '<p>A passionate developer with over 10 years of experience.</p>',
  skills: [
    {id: '1', label: 'JavaScript'},
    {id: '3', label: 'React'},
  ],
  profilePicture: [
    {
      name: 'profile.jpg',
      value: 'https://example.com/profile.jpg',
      type: 'image/jpeg',
      file: {name: 'profile.jpg'},
    },
  ],
  termsAccepted: true,
  signature: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAA...',
};

export const FormViewComponentV2Example: React.FC = () => {
  return (
    <Box p="md">
      <Title order={2} mb="lg">
        Form View Example
      </Title>
      <FormViewComponentV2
        formMeta={exampleFormMeta}
        formData={exampleFormData}
        limitItemsCount={5}
      />
    </Box>
  );
};
